<script>
import { Icon } from "ant-design-vue";

const IconFont = Icon.createFromIconfontCN({
  scriptUrl: "//at.alicdn.com/t/font_1926328_pv3as5txr1.js",
});

export default IconFont;
</script>
